export default __webpack_public_path__ + "static/why-peep-a9b71027f7b59093040ad67c1e2e2c14.svg";